export const WIDTH = 36;
export const LEFT_SPACE = 56;
export const TOP_SPACE = 30;
export const DEFAULT_HEIGHT = 24;
